import { ORGANS } from "./organs";
import { ELEMENTS } from "./elements";
import { EMOTIONS } from "./emotions";
import { SYMPTOMS } from "./symptoms";
import { TEAS } from "./teas";
import { FOODS } from "./foods";
import { FLAVORS } from "./flavors";
import { HABITS_BY_ELEMENT } from "./practices";
import { CLOCK } from "./clock";

const normalize = (str) =>
  (str || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

// Índice de busca construído SOMENTE a partir do conteúdo do guia.
export const buildSearchIndex = () => {
  const idx = [];

  ORGANS.forEach((o) => {
    const extra = [
      o.funcao,
      o.emocao,
      o.elementoLabel,
      o.sabor,
      ...(o.habitos || []),
      ...(o.alimentos || []),
      ...(o.chas || []).map((c) => c.nome),
      ...(o.funcoesPrincipais || []),
      o.relogio?.periodo,
    ].join(" ");
    idx.push({
      type: "Órgão",
      title: o.name,
      subtitle: o.subtitle,
      to: `/orgaos/${o.id}`,
      haystack: normalize(`${o.name} ${o.subtitle} ${o.intro} ${extra}`),
    });
  });

  ELEMENTS.forEach((e) => {
    idx.push({
      type: "Elemento",
      title: e.name,
      subtitle: e.qualidades,
      to: `/elementos/${e.id}`,
      haystack: normalize(`${e.name} ${e.palavras.join(" ")} ${e.descricao} ${e.emocao} ${e.sabor} ${e.orgaos.join(" ")} ${e.qualidades} ${e.desequilibrio}`),
    });
  });

  EMOTIONS.forEach((em) => {
    idx.push({
      type: "Emoção",
      title: em.emocao,
      subtitle: em.orgaos.join(", "),
      to: `/emocoes`,
      haystack: normalize(`${em.emocao} ${em.orgaos.join(" ")} ${em.funcaoPositiva} ${em.excessoBloqueio} ${em.sinaisFisicos}`),
    });
  });

  SYMPTOMS.forEach((s) => {
    idx.push({
      type: "Sintoma",
      title: s.sintoma,
      subtitle: s.relacoes,
      to: `/sintomas`,
      haystack: normalize(`${s.sintoma} ${s.relacoes}`),
    });
  });

  TEAS.forEach((t) => {
    idx.push({
      type: "Chás",
      title: t.foco,
      subtitle: t.chas.join(", "),
      to: `/chas`,
      haystack: normalize(`${t.foco} ${t.chas.join(" ")} ${t.orgaos} ${t.cuidado}`),
    });
  });

  FOODS.forEach((f) => {
    idx.push({
      type: "Alimentos",
      title: `Alimentos — ${f.orgaos}`,
      subtitle: f.exemplos.join(", "),
      to: `/alimentos`,
      haystack: normalize(`${f.orgaos} ${f.sabor} ${f.exemplos.join(" ")} ${f.nota}`),
    });
  });

  FLAVORS.forEach((fl) => {
    idx.push({
      type: "Sabor",
      title: fl.sabor,
      subtitle: fl.orgaos,
      to: `/sabores`,
      haystack: normalize(`${fl.sabor} ${fl.orgaos} ${fl.equilibrio} ${fl.excesso}`),
    });
  });

  HABITS_BY_ELEMENT.forEach((h) => {
    idx.push({
      type: "Hábitos",
      title: `Hábitos — ${h.qualidade}`,
      subtitle: h.habitos.join(", "),
      to: `/autocuidado`,
      haystack: normalize(`${h.qualidade} ${h.orgaos} ${h.habitos.join(" ")}`),
    });
  });

  CLOCK.forEach((c) => {
    idx.push({
      type: "Relógio",
      title: `${c.periodo} — ${c.orgao}`,
      subtitle: c.cuidado,
      to: `/relogio`,
      haystack: normalize(`${c.periodo} ${c.orgao} ${c.descricao} ${c.cuidado}`),
    });
  });

  return idx;
};

export const SEARCH_INDEX = buildSearchIndex();

export const searchGuide = (query) => {
  const q = normalize(query.trim());
  if (!q) return [];
  return SEARCH_INDEX.filter((item) => item.haystack.includes(q)).slice(0, 24);
};
